/*
 * frost-whats-inside.js (owner: CONTENT) – <fb-count-up data-to="108">
 * Counts the big number up once when it enters the viewport. The real number is always in the
 * markup (no JS = static "108"), screen readers get a visually hidden copy. The width is locked
 * first so the label next to the number never jumps.
 * full: 1.2 s strong ease-out, soft: 1.4 s (digits only, nothing moves), none: static.
 * The rest of the section (box opens, decks rise, bar fills) is pure CSS on .is-revealed.
 */
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('fb-count-up')) return;

  function motion() {
    if (window.FROSTBEULE && typeof window.FROSTBEULE.motion === 'function') return window.FROSTBEULE.motion();
    return document.documentElement.getAttribute('data-motion') || 'full';
  }

  window.customElements.define(
    'fb-count-up',
    class extends HTMLElement {
      connectedCallback() {
        this.to = parseInt(this.getAttribute('data-to'), 10);
        this.num = this.querySelector('[data-fb-count-num]');
        if (!this.num || !(this.to > 0) || this.done) return;
        if (motion() === 'none' || !('IntersectionObserver' in window) || !window.requestAnimationFrame) return;

        var self = this;
        var first = true;
        this.io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                self.disconnectObserver();
                self.run();
              } else if (first) {
                /* still below the fold: park at 0 (invisible – the reveal fade has not started) */
                self.lockWidth();
                self.num.textContent = '0';
              }
              first = false;
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0 }
        );
        this.io.observe(this);
      }

      disconnectedCallback() {
        this.disconnectObserver();
        if (this.raf) window.cancelAnimationFrame(this.raf);
        this.raf = null;
        this.finish();
      }

      disconnectObserver() {
        if (this.io) this.io.disconnect();
        this.io = null;
      }

      lockWidth() {
        if (this.locked || !this.num) return;
        this.num.style.minWidth = Math.ceil(this.num.getBoundingClientRect().width) + 'px';
        this.locked = true;
      }

      finish() {
        if (this.num && this.to > 0) this.num.textContent = String(this.to);
        this.done = true;
      }

      run() {
        var mode = motion();
        if (mode === 'none' || document.hidden) {
          this.finish();
          return;
        }
        this.lockWidth();
        var self = this;
        var num = this.num;
        var to = this.to;
        var duration = mode === 'soft' ? 1400 : 1200;
        var start = null;
        num.textContent = '0';

        function step(now) {
          if (start === null) start = now;
          var p = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - p, 4);
          num.textContent = String(Math.round(to * eased));
          if (p < 1) {
            self.raf = window.requestAnimationFrame(step);
          } else {
            self.raf = null;
            self.finish();
          }
        }
        this.raf = window.requestAnimationFrame(step);
      }
    }
  );
})();
